//get Movie
export const GET_TV_SERIES = "GET_TV_SERIES";

//get top 10 Movie
// export const GET_TOP_10_MOVIE = "GET_TOP_10_MOVIE";

//get top 10 web-series
// export const GET_TOP_10_WEB_SERIES = "GET_TOP_10_WEB_SERIES";

//Movie Details
export const TV_SERIES_DETAILS = "TV_SERIES_DETAILS";

//dialog type
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//insert
export const INSERT_TV_SERIES = "INSERT_TV_SERIES";

//update
export const UPDATE_TV_SERIES = "UPDATE_TV_SERIES";

//delete Movie
export const DELETE_TV_SERIES = "DELETE_TV_SERIES";

//isNewRelease Switch
export const IS_NEW_RELEASE_SWITCH = "IS_NEW_RELEASE_SWITCH";

//get comment
export const GET_COMMENT = "GET_COMMENT";

//delete comment
export const DELETE_COMMENT = "DELETE_COMMENT";

//toast
export const OPEN_TV_SERIES_TOAST = "OPEN_TV_SERIES_TOAST";
export const CLOSE_TV_SERIES_TOAST = "CLOSE_TV_SERIES_TOAST";

//Movie Details From TMDB
export const TV_SERIES_DETAILS_TMDB = "TV_SERIES_DETAILS_TMDB";

const uploadFileTypes = {
  SET_UPLOAD_FILE: "SET_UPLOAD_FILE",

  SET_UPLOAD_PROGRESS: "SET_UPLOAD_PROGRESS",
  SUCCESS_UPLOAD_FILE: "SUCCESS_UPLOAD_FILE",
  FAILURE_UPLOAD_FILE: "FAILURE_UPLOAD_FILE",
};

export default uploadFileTypes;


export const  MANUAL_CREATE_SERIES ="  MANUAL_CREATE_SERIES"

export const  EMPTY_TMDB_SERIES_DIALOGUE ="  EMPTY_TMDB_SERIES_DIALOGUE"
